<template>
  <div class="fts-information-modal">
    <modal
      class="state-modal"
      :height="'auto'"
      :width="'800px'"
      @before-open="beforeOpen"
      name="nestedInformationModal"
    >
      <div class="modal-title">
        <div>Nested Information</div>
      </div>
      <div class="state-modal-body">
        <fts-form :fields="form" :formData="formData" :form="form"></fts-form>

        <div v-if="formData.type == 14">
          <div>
            <!-- Columns -->
            <div class="modal-classification">
              <div class="modal-sub-title">Fields</div>
              <div class="classification-wrapper">
                <draggable v-model="formData.columns">
                  <div
                    @click="showInformation(information)"
                    v-for="(information, index) in formData.columns"
                    :key="information.id"
                    :class="{ 'over': show == index }"
                    @mouseover="show = index"
                    @mouseleave="show = -1"
                    class="list-item"
                  >
                    <div class="list-detail">
                      <i
                        style="color: orange;"
                        :class="getIcon(information.type)"
                        class="field-icon"
                      ></i>
                      <span>{{information.id}} - {{information.displayName}}</span>
                    </div>
                    <div class="settings" v-if="show == index">
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                        fixed-width
                        class="fet-danger-color"
                      />
                      <font-awesome-icon :icon="['fas', 'cog']" fixed-width />
                    </div>
                  </div>
                </draggable>

                <div class="classification-action">
                  <input
                    class="classification-name"
                    v-model="newInformation.displayName"
                    :placeholder="'create field'"
                    taggable
                    label="displayName"
                    :options="information"
                  />
                  <v-select
                    class="classification-type"
                    v-model="newInformation.type"
                    :reduce="type => type.id"
                    label="type"
                    :options="informationTypes"
                  ></v-select>
                  <button
                    class="fet-btn fet-btn-outline"
                    type="button"
                    @click="addInformation()"
                  >Add</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fts-v-modal-content-footer">
          <div>
            <button type="button" class="fts-btn fts-btn-text fts-btn-danger fts-btn-icon-mr float-left" @click="deleteInformation()">
              <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />Delete
            </button>
          </div>
          <div>
            <button type="button" class="fts-btn fts-btn-raised fts-btn-primary fts-btn-icon-mr" @click="confirmInformation()">
              <font-awesome-icon :icon="['fas', 'check']" fixed-width />Done
            </button>
          </div>
        </div>
    </modal>
  </div>
</template>

<script>
import FETContenteditable from "../FETContenteditable";
import { cloneDeep } from "lodash";
import FTSForm from "../elements/FTSForm";
import commons from "../commons/commons";
import moment from "moment";
import draggable from "vuedraggable";
import vSelect from "../vue-select/index";

export default {
  mounted() {},
  computed: {
    states() {
      return this.$store.state.canvas.states;
    },
    information() {
      return this.$store.state.canvas.information;
    },
    flows() {
      return this.$store.state.canvas.flows;
    },
    activities() {
      return this.$store.state.canvas.activities;
    }
  },
  data() {
    return {
      show: -1,
      newInformation: {},
      dateFormatSelection: commons.dateFormats,
      informationTypes: commons.informationTypes,
      formData: {},
      form: {
        rows: [
          //   {
          //     items: [
          //       {
          //         displayName: "Read Only",
          //         fieldName: "readOnly",
          //         input: "boolean"
          //       },
          //     ]
          //   },
          {
            items: [
              {
                displayName: "Name",
                fieldName: "displayName",
                input: "text"
              },
              {
                displayName: "Label (Optional)",
                fieldName: "label",
                input: "text"
              }
            ]
          },
          {
            items: [
              {
                displayName: "Description",
                fieldName: "description",
                input: "textArea"
              }
            ]
          },
          {
            items: [
              {
                displayName: "Type",
                key: "type",
                fieldName: "typeText",
                input: "dropDown",
                displayProperty: "type",
                optionList: commons.informationTypes
              },
              {
                displayName: "Format",
                fieldName: "predefinedFormat",
                input: "dropDown",
                optionList: this.formatSelection(this.formData),
                hiddenFunc: formData => this.hidden("format", formData)
              }
            ]
          },
          {
            items: [
              {
                displayName: "Prefix",
                fieldName: "prefix",
                input: "text",
                hiddenFunc: formData => this.hidden("prefix", formData)
              },
              {
                input: "empty"
              }
            ]
          },
          {
            items: [
              {
                displayName: "With time",
                fieldName: "withTime",
                input: "boolean",
                hiddenFunc: formData => this.hidden("withTime", formData)
              },
              {
                input: "empty"
              }
            ]
          },

          {
            items: [
              {
                displayName: "Lookup",
                fieldName: "connection",
                key: "connectionId",
                input: "dropDown",
                hiddenFunc: formData => this.hidden("lookup", formData)
              },
              {
                displayName: "Preload",
                fieldName: "test",
                input: "boolean",
                hiddenFunc: formData => this.hidden("lookup", formData)
              }
            ]
          },
          {
            items: [
              {
                displayName: "Formula",
                fieldName: "test",
                input: "text",
                hiddenFunc: formData => this.hidden("formula", formData)
              }
            ]
          },
          {
            items: [
              {
                displayName: "Allow multiple",
                fieldName: "allowMultiple",
                input: "boolean",
                hiddenFunc: formData => this.hidden("allowMultiple", formData)
              },
              {
                input: "empty"
              }
            ]
          },
          {
            items: [
              {
                displayName: "Options",
                fieldName: "optionList",
                input: "table",
                columns: [
                  {
                    displayName: "Name",
                    fieldName: "name",
                    input: "text"
                  },
                  {
                    displayName: "Color",
                    input: "color"
                  }
                ],
                hiddenFunc: formData => this.hidden("options", formData)
              }
            ]
          }
        ]
      }
    };
  },
  components: {
    "fet-contenteditable": FETContenteditable,
    "fts-form": FTSForm,
    draggable,
    "v-select": vSelect
  },
  methods: {
    getIcon(typeId) {
      return "icon-" + commons.getInformationIcon(typeId);
    },
    beforeOpen(event) {
      let payload = event.params;
      if (payload.item) {
        this.formData = _.cloneDeep(payload.item);
      }
    },
    formatSelection(formData) {
      return commons.dateFormats
    },
    hidden(type, formData) {
      if (type == "format") {
        if (formData.type == 5 || formData.type == 6) return false;
      } else if (type == "prefix") {
        if (formData.type == 4) return false;
      } else if (type == "withTime") {
        if (formData.type == 5 || formData.type == 6) return false;
      } else if (type == "allowMultiple") {
        if ([10, 12, 7, 20].some(y => formData.type == y)) return false;
      } else if (type == "lookup") {
        if ([7, 8, 20].some(y => formData.type == y)) return false;
      } else if (type == "formula") {
        if ([32].some(y => formData.type == y)) return false;
      } else if (type == "formula") {
        if ([27].some(y => formData.type == y)) return false;
      }

      return true;
    },
    deleteInformation(information) {
      this.$emit("delete", this.formData);
      this.$modal.hide("nestedInformationModal");
    },
    confirmInformation() {
      this.formData.fieldName = commons.camelize(this.formData.displayName);
      this.$emit("confirm", this.formData);
      this.$modal.hide("nestedInformationModal");
    },
    showInformation(item) {
      this.$modal.show("informationModal", { item, inTable: true });
    }
  }
};
</script>

<style lang="scss">
.fts-information-modal {
  @media (min-width: 768px) {
    .fts-form-container .fts-form-item {
      .fts-form-element-container.compact-form-design .fts-form-label {
        min-width: 100px;
        width: 100px;
      }
    }
  }
}
</style>